var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMorningIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 52,
  height: 52,
  viewBox: "0 0 52 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.8857 12C33.759 12 40.1416 18.3826 40.1416 26.2559C40.1416 27.5157 39.9767 28.7369 39.6699 29.9004H12.1016C11.7948 28.737 11.6299 27.5157 11.6299 26.2559C11.6299 18.3826 18.0125 12 25.8857 12Z",
  fill: "#F9B444"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 29.9004H46.11",
  stroke: "#F9B444",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5454 35.207L40.8067 35.207",
  stroke: "#F9B444",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9336 35.207L22.9012 35.207",
  stroke: "#F9B444",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9585 40.5137L18.9261 40.5137",
  stroke: "#F9B444",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5654 40.5137L26.2177 40.5137",
  stroke: "#F9B444",
  strokeWidth: 2.65226,
  strokeLinecap: "round"
})));
export default SvgMorningIcon;